
        
    const runtime = require("../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
            const __nunjucks_template_import__filter_t = require("../../../nunjucks/t.js");
            __nunjucks_module_dependencies__.filters['t'] = {
                module: __nunjucks_template_import__filter_t && __nunjucks_template_import__filter_t.default || __nunjucks_template_import__filter_t,
                async: false
            };
    
        
            __nunjucks_module_dependencies__.templates["note/views/templates/note-blank-slate.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<ul class=\"pathicons-container\">\n  <li><i class=\"pwai-image\"></i></li>\n  <li><i class=\"pwai-avatar-o\"></i></li>\n  <li><i class=\"pwai-page\"></i></li>\n  <li><i class=\"pwai-avatar-o\"></i></li>\n  <li><i class=\"pwai-chat\"></i></li>\n  <li><i class=\"pwai-avatar-o\"></i></li>\n</ul>\n";
if(runtime.contextOrFrameLookup(context, frame, "has_access")) {
output += "\n<!-- upddate the data-content message -->\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perms")),"can_post_note")) {
output += "\n<div\n  class=\"add-note-container\"\n  data-container=\".add-note-container\"\n  data-toggle=\"popover\"\n  data-placement=\"bottom\"\n  data-content=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabledMessage"), env.opts.autoescape);
output += "\"\n  data-original-title=\"\"\n  title=\"\"\n>\n  <button\n    id=\"add-note\"\n    class=\"ButtonLegacy medium rounded primary interactive inverted brand-color\"\n  >\n    ";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.blank_slate.add_note"), env.opts.autoescape);
output += "\n  </button>\n</div>\n<p>\n  ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perms")),"can_post_curriculum_note") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perms")),"can_post_course_note")) {
output += " ";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.blank_slate.content"), env.opts.autoescape);
output += " ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "title")) {
output += " ";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.blank_slate.private_content",{"title": runtime.contextOrFrameLookup(context, frame, "title")}), env.opts.autoescape);
output += " ";
;
}
else {
output += " ";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.blank_slate.can_attach"), env.opts.autoescape);
;
}
;
}
output += "\n  <!--\n    Post notes, images and videos for yourself, other staff, or students. You can always choose who can see what you add.\n  -->\n</p>\n";
;
}
else {
output += "\n<p>";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.blank_slate.no_other_notes"), env.opts.autoescape);
output += "</p>\n";
;
}
output += " ";
;
}
else {
output += "\n<p>";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.blank_slate.take_notes"), env.opts.autoescape);
output += "</p>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "note/views/templates/note-blank-slate.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "note/views/templates/note-blank-slate.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["note/views/templates/note-blank-slate.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    